// extracted by mini-css-extract-plugin
export default {"title":"l8lzLWV w3QwoQC"};